import TechniquesTable from './TechniquesTable';

export default TechniquesTable;
